import intersection from "lodash/intersection";
import { getWindow, notEmpty } from "~/lib/utils";
const getIsGeoTargeting = ({
  geoTargeting,
  userCountry
}) => {
  if (!geoTargeting) {
    return true;
  }
  const {
    type,
    userCountries
  } = geoTargeting;
  if (userCountries.length === 0) {
    return true;
  }
  switch (type) {
    case "exclude":
      return !userCountries.includes(userCountry);
    case "include":
      return userCountries.includes(userCountry);
    default:
      return true;
  }
};
const getIsPageTargeting = ({
  location,
  pageTargeting
}) => {
  if (!location || !pageTargeting) {
    return true;
  }
  const {
    excludedPathnameRegexList,
    excludedURLList,
    includedPathnameRegexList,
    includedURLList
  } = pageTargeting;
  const isExcludedPathnameMatched = !excludedPathnameRegexList || excludedPathnameRegexList.every(excludedPathnameRegex => !new RegExp(excludedPathnameRegex).test(location.pathname));
  const isExcludedURLMatched = !excludedURLList || excludedURLList.every(excludedURL => !location.href.includes(excludedURL));
  const isIncludedPathnameMatched = !includedPathnameRegexList || includedPathnameRegexList.length === 0 || includedPathnameRegexList.some(includedPathnameRegex => new RegExp(includedPathnameRegex).test(location.pathname));
  const isIncludedURLMatched = !includedURLList || includedURLList.length === 0 || includedURLList.some(includedURL => location.href.includes(includedURL));
  return isExcludedPathnameMatched && isExcludedURLMatched && isIncludedPathnameMatched && isIncludedURLMatched;
};
const getIsUserTypeTargeting = ({
  userTypeIds,
  userTypeTargeting
}) => {
  if (!notEmpty(userTypeTargeting)) {
    return true;
  }
  if (!notEmpty(userTypeIds)) {
    return false;
  }
  return notEmpty(intersection(userTypeIds, userTypeTargeting));
};
export const getShouldShow = ({
  config,
  userInfo
}) => {
  var _config$disableWithLo, _getWindow;
  const hasNotShownYet = [config.localStorageKey, ...((_config$disableWithLo = config.disableWithLocalStorageKeys) !== null && _config$disableWithLo !== void 0 ? _config$disableWithLo : [])].every(localStorageKey => localStorage.getItem(localStorageKey) === null);
  const isGeoTargeting = getIsGeoTargeting({
    geoTargeting: config.geoTargeting,
    userCountry: userInfo.userCountry
  });
  const isPageTargeting = getIsPageTargeting({
    location: (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.location,
    pageTargeting: config.pageTargeting
  });
  const isUserTypeTargeting = getIsUserTypeTargeting({
    userTypeIds: userInfo.userTypeIds,
    userTypeTargeting: config.userTypeTargeting
  });
  const isTargetUser = config.anonymous && !userInfo.isLoggedIn || config.login && userInfo.isLoggedIn;
  return hasNotShownYet && isGeoTargeting && isPageTargeting && isUserTypeTargeting && isTargetUser;
};
export const getLoginDialogTitleAndDescription = parameters => {
  const {
    campaignName,
    type
  } = parameters;
  return {
    description: `Log in or register to follow <span class="bold-text">${campaignName}</span> and get notified on newly published stories.`,
    title: `Get notified on your favourite ${type}`
  };
};